'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import 'select2';
import passRules from '../../modules/passRules';
import { recaptchaUpdater } from '../../modules/recaptcha';
import { stateCity } from '../../modules/select';

const showRegistrationForm = {
  bindActions() {
    recaptchaUpdater('register');

    $('form').bind('keypress', function (e) {
      if (e.keyCode == 13 || event.key === 'Enter') {
        return false;
      }
    });

    $('.continue').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');
      let $steps = $('.js-steps');

      if (currentSlide == 'first') {
        if ($('#cpf-error').hasClass('error')) {
          Swal.fire({ icon: 'error', title: 'Atenção!', text: 'Não é possível prosseguir com o seu cadastro.' });
          return false;
        }

        if ($("input[name='cpf']").val() == '' || $("input[name='name']").val() == '') {
          Swal.fire({ icon: 'error', title: 'Atenção!', text: 'Preencha os campos corretamente' });
          return false;
        }

        var dateFrom = '01/01/1900';
        var today = new Date();
        var dateTo = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
        var dateCheck = $('.js-form-date').val();

        var d1 = dateFrom.split('/');
        var d2 = dateTo.split('/');
        var c = dateCheck.split('/');

        var from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]);
        var to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
        var check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

        if (check == 'Invalid Date' || parseInt(c[1]) - 1 > 11 || c[0] > 31 || check < from || check > to) {
          Swal.fire('Atenção!', 'Data de nascimento inválida', 'error');
          return false;
        }
      }

      if (currentSlide == 'state') {
        if ($('.js-state-filter').val() == '' || $('.js-cities').val() == '') {
          Swal.fire({
            icon: 'error',
            title: 'Atenção!',
            text: 'Preencha os campos corretamente',
          });
          return false;
        }
      }

      if (currentSlide == 'rede') {
        if ($("input[name='enrollment']").val() == '') {
          Swal.fire({
            icon: 'error',
            title: 'Atenção!',
            text: 'Preencha os campos corretamente',
          });
          return false;
        }
      }

      if (currentSlide == 'contact') {
        if (
          $("input[name='email']").val() == '' ||
          $("input[name='mobile_phone']").val() == '' ||
          $('#email-error').hasClass('error')
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Atenção!',
            text: 'Preencha os campos corretamente',
          });
          return false;
        }
      }

      if (currentSlide == 'questions') {
        if (
          $('#volunteer_work_participated').val() == '' ||
          $('#interest_causes').val() == '' ||
          $('#availability').val() == ''
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Atenção!',
            text: 'Preencha os campos corretamente',
          });
          return false;
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
      $steps.find(`[data-step="${nextSlide}"]`).addClass('active');
    });

    $('.back').on('click', function (e) {
      e.preventDefault();
      console.log('anterior');

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');
      let $steps = $('.js-steps');

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
      $steps.find(`[data-step="${currentSlide}"]`).removeClass('active');
    });

    $('.js-rede').on('change', function () {
      if ($("input[name='is_rede']:checked").val() == '1') {
        $('#is_rede_options').removeClass('u-display--none');
        $('#is_regional_options').removeClass('u-display--none');
      } else {
        $('#is_rede_options').addClass('u-display--none');
        $('#is_regional_options').addClass('u-display--none');
      }
    });

    $('.js-form-cpf').on('change keyup paste', function (e) {
      e.preventDefault();

      var cpf = $(this).val();
      if (cpf != '') {
        var validacpf = /^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/;

        if (validacpf.test(cpf)) {
          getCpf(cpf);
        } else {
          $('#cpf-error').text('');
          $('#cpf-error').removeClass('error');
        }
      }
    });

    function getCpf(cpf) {
      var url = '/check-cpf/' + cpf;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#cpf-error').text(response.message);
            $('#cpf-error').addClass('error');
          }
        },
        error: function (jqXHR, status, error) {
          console.log(error);
        },
      });
    }

    $('.js-form-email').on('change keyup paste', function (e) {
      e.preventDefault();

      var email = $(this).val();
      if (email != '') {
        getEmail(email);
      }
    });

    function getEmail(email) {
      var url = '/check-email/' + email;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#email-error').text(response.message);
            $('#email-error').addClass('error');
          } else {
            $('#email-error').text('');
            $('#email-error').removeClass('error');
          }
        },
        error: function (jqXHR, status, error) {
          console.log(error);
        },
      });
    }

    $('#form-signin').on('submit', function (e) {
      e.preventDefault();

      let checkLength = $('.js-check').length;

      if ($('.js-check:checked').length !== checkLength) {
        Swal.fire('Você deve aceitar os termos para continuar!', '', 'error');
        return false;
      } else {
        e.target.submit();
      }
    });

    $('.js-worked')
      .select2({
        placeholder: 'Selecione',
        theme: 'classic',
        multiple: true,
      })
      .on('select2:select', function (e) {
        if ($('.js-worked').val().includes('Não')) {
          $(this).val(e.params.data.text).trigger('change');
        }
      });

    $('.js-interest').select2({
      placeholder: 'Selecione',
      theme: 'classic',
      multiple: true,
    });

    $(document).on('click', '#btn-register', function (e) {
      if (!passRules.settings.submit) {
        e.preventDefault();
        Swal.fire('Preencha uma senha válida!', '', 'error');
      }

      if ($('.js-check:checked').length !== $('.js-check').length) {
        e.preventDefault();
        Swal.fire('Você deve aceitar os termos para continuar!', '', 'error');
      }
    });
  },

  init() {
    passRules.init();
    _this.bindActions();
    stateCity();
  },
};

const s = showRegistrationForm.settings,
  _this = showRegistrationForm;

export default _this;
